                                                  
import {connect} from "react-redux";
                                                  
                                    
import {customHistory} from "../helper/history";
import {resetPage, setPage, setSearchPhrase, SPECIAL_CATEGORY, submitSearchPhrase} from "../actions/filter";
import SearchPage from "../components/SearchPage";
import {getProducts} from "../actions/products";

                                 
                       
                      
                          
                    
                   
  

function mapStateToProps(state                  , props                          ) {
	return {
		products: state.content.products,
		searchPhrase: state.filter.fuzzy,
		selectedCategory: state.filter.filter.selectedCategory && state.filter.filter.selectedCategory.title !== SPECIAL_CATEGORY.TOP ? state.filter.filter.selectedCategory.title : "",
		currentPageIndex: state.filter.filter.page,
		totalItems: state.filter.filter.totalItems,
		totalPages: state.filter.filter.totalPages,
		itemsPerPage: state.filter.filter.itemsPerPage
	};
}

function mapDispatchToProps(dispatch          , state                  ) {
	return {
		goHome: () => customHistory.push("/"),
		setSearch: (fuzzy        ) => {
			dispatch(resetPage());
			dispatch(setSearchPhrase(fuzzy));
			dispatch(submitSearchPhrase(fuzzy));
		},
		setPage: (page        ) => {
			dispatch(setPage(page));
			dispatch(getProducts());
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);
